import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Page from 'flarum/common/components/Page';
import IndexPage from 'flarum/forum/components/IndexPage';
import extractText from 'flarum/common/utils/extractText';
import Tooltip from 'flarum/common/components/Tooltip';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Avatar from 'flarum/common/components/Avatar';
import ScopeComponent from '../ScopeComponent';
export default class AuthorizePage extends IndexPage {
  params = [];
  client = null;
  scopes = null;
  client_scope = [];
  loading = true;
  is_authorized = false;
  submit_loading = false;
  display_mode = 'box';
  oninit(vnode) {
    super.oninit(vnode);
    if (!app.session.user) {
      setTimeout(() => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal')), 500);
      return;
    }
    this.display_mode = app.forum.attribute('foskym-oauth-center.display_mode') || 'box';
    const params = m.route.param();
    if (params.client_id == null || params.response_type == null || params.redirect_uri == null) {
      m.route.set('/');
      return;
    }
    this.params = params;
    Promise.all([app.store.find('oauth-clients', params.client_id), app.store.find('oauth-scopes')]).then(([client, scopes]) => {
      if (!client) {
        m.route.set('/');
        return;
      }
      this.client = client;
      this.scopes = scopes;
      let uris = this.client.redirect_uri().split(' ');
      if (app.forum.attribute('foskym-oauth-center.require_exact_redirect_uri') && !uris.includes(params.redirect_uri)) {
        m.route.set('/');
        return;
      }
      if (!app.forum.attribute('foskym-oauth-center.allow_implicit') && params.response_type === 'token') {
        m.route.set('/');
        return;
      }
      if (app.forum.attribute('foskym-oauth-center.enforce_state') && params.state == null) {
        m.route.set('/');
        return;
      }
      let scopes_temp = params.scope ? params.scope.split(' ') : (this.client.scope() || '').split(' ');
      let default_scopes = this.scopes.filter(scope => scope.is_default() === 1).map(scope => scope.scope());
      this.client_scope = scopes_temp.filter((scope, index) => scopes_temp.indexOf(scope) === index);
      this.client_scope = this.client_scope.concat(default_scopes).filter(scope => scope !== '');
      this.loading = false;
      m.redraw();
    });
  }
  setTitle() {
    app.setTitle(extractText(app.translator.trans('foskym-oauth-center.forum.page.title.authorize')));
    app.setTitleCount(0);
  }
  view() {
    if (!this.client || this.loading) {
      return m(LoadingIndicator, null);
    }
    return m("div", {
      className: "AuthorizePage"
    }, m("div", {
      className: "container"
    }, m("div", {
      class: "oauth-area"
    }, m("div", {
      class: 'oauth-main oauth-' + this.display_mode
    }, m("div", {
      class: "oauth-header"
    }, m("h2", null, app.forum.attribute('title')), m("p", null, app.translator.trans('foskym-oauth-center.forum.authorize.access'), " ", m(Tooltip, {
      text: this.client.client_desc(),
      position: "bottom"
    }, m("a", {
      href: this.client.client_home(),
      target: "_blank"
    }, this.client.client_name())))), m("div", {
      class: "oauth-body"
    }, m("div", {
      class: "oauth-user"
    }, m(Avatar, {
      user: app.session.user,
      className: "oauth-avatar"
    }), m("div", {
      class: "oauth-username"
    }, m("b", null, app.session.user.username()), m("span", null, app.session.user.displayName()))), m("div", {
      class: "oauth-info"
    }, m(Tooltip, {
      text: app.forum.attribute('title')
    }, m("img", {
      src: app.forum.attribute('faviconUrl'),
      alt: "favicon"
    })), m("i", {
      class: "fas fa-exchange-alt fa-2x"
    }), m(Tooltip, {
      text: this.client.client_desc()
    }, m("img", {
      src: this.client.client_icon(),
      alt: "client_icon"
    })), m("span", null, this.client.client_name())), m("div", {
      class: "oauth-scope-area"
    }, m("h3", null, app.translator.trans('foskym-oauth-center.forum.authorize.require_these_scopes')), this.client_scope.filter(scope => scope).map(scope => {
      let scope_info = this.scopes.find(s => s.scope() === scope);
      return scope_info && m(ScopeComponent, {
        scope: scope_info,
        client: this.client
      });
    })), m("form", {
      class: "oauth-form",
      method: "post",
      id: "form",
      action: "/oauth/authorize",
      onsubmit: this.onsubmit.bind(this)
    }, Object.keys(this.params).map(key => m("input", {
      type: "hidden",
      name: key,
      value: this.params[key]
    })), m("input", {
      type: "hidden",
      name: "is_authorized",
      value: this.is_authorized
    }), m("div", {
      class: "oauth-form-item oauth-btn-group"
    }, m(Button, {
      className: "Button",
      type: "submit",
      style: "width: 50%;",
      onclick: this.deny.bind(this),
      loading: this.submit_loading
    }, app.translator.trans('foskym-oauth-center.forum.authorize.deny')), m(Button, {
      className: "Button Button--primary",
      type: "submit",
      style: "width: 50%;",
      onclick: this.agree.bind(this),
      loading: this.submit_loading
    }, app.translator.trans('foskym-oauth-center.forum.authorize.agree')))))))));
  }
  deny(e) {
    this.is_authorized = false;
  }
  agree(e) {
    this.is_authorized = true;
  }
  onsubmit(e) {
    e.preventDefault();
    this.submit_loading = true;
    if (app.forum.attribute('foskym-oauth-center.authorization_method_fetch')) {
      app.request({
        method: 'POST',
        url: '/oauth/authorize/fetch',
        body: {
          ...this.params,
          is_authorized: this.is_authorized
        }
      }).then(params => {
        window.location.href = params.location;
      });
    } else {
      e.target.submit();
    }
  }
}
flarum.reg.add('foskym-oauth-center', 'forum/components/oauth/AuthorizePage', AuthorizePage);